<template>
  <form method="post" class="comment-form" @submit.prevent="submit">
    <div class="form-group comment-form-message" v-bind:class="{ 'has-error': errors.comment }">
      <figure>
        <img :src="user.avatar_fallback" class="img-circle img-avatar">
      </figure>

      <div>
        <textarea
          class="form-control"
          v-model="comment"
          id="comment"
          placeholder="Typ hier je bericht..."
          rows="5"
        ></textarea>
      </div>
    </div>

    <p class="alert alert-danger m-top-10" v-if="uploadError">
      Er ging iets fout bij het uploaden van bestanden. Probeer het nogmaals.
    </p>

    <ul v-if="files.length > 0" class="comment-form-files list-unstyled">
      <li v-for="file in files">
        {{ file.file_name }}
        <a @click="remove(file)" class="m-left-5"><i class="fa fa-remove fa-lg"></i></a>
      </li>
    </ul>

    <div class="comment-form-btns">
      <label class="btn">
        <input
          type="file"
          accept="image/jpeg,image/gif,image/png,application/pdf"
          multiple="multiple"
          @change="upload"
          class="hidden"
        >

        <i class="fa fa-cloud-upload fa-fw"></i> {{ uploading ? 'Uploaden...' : selectFilesLabel }}
      </label>

      <div class="dropdown dropup" v-if="userCommentTypes">
        <button type="button" class="btn dropdown-toggle" data-toggle="dropdown"><i class="fa fa-users fa-fw"></i>
          {{ commentTypeText }}
        </button>

        <ul class="dropdown-menu dropdown-menu-right">
          <li v-for="(type, key) in userCommentTypes"><a @click="selectCommentType(key, type)">{{ type }}</a></li>
        </ul>
      </div>

      <button type="submit" class="btn" ref="submitbtn" :disabled="submitting">
        <template v-if="submitting">
          <i class="fa fa-spin fa-circle-o-notch"></i>
          Bezig met plaatsen...
        </template>

        <template v-else>
          <i class="fa fa-send fa-fw"></i>
          Plaats bericht
        </template>
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: 'JobCommentForm',

  props: {
    jobId: {
      type: Number,
      required: true,
    },

    user: {
      type: Object,
      required: true,
    },

    jobDeleted: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      comment: '',
      jobCommentId: null,
      uploading: false,
      submitting: false,
      selectFilesLabel: 'Selecteer bestanden',
      files: [],
      errors: {},
      commentTypes: {
        1: 'Klant',
        2: 'Chauffeur',
        3: 'Openbaar',
        4: 'Intern',
      },
      commentTypeText: 'Chauffeur',
      commentType: 2, // driver
      uploadError: false
    }
  },

  created: function () {
    if (this.user.role !== 'admin') {
      this.commentType = 1;
      this.commentTypeText = 'Klant';
    }

    if (this.jobDeleted) {
      this.commentType = 4;
      this.commentTypeText = 'Intern';
    }
  },

  computed: {
    userCommentTypes() {
      if (this.user.role !== 'admin') {
        return null;
      }

      if (this.jobDeleted) {
        return { 4: 'Intern' };
      }

      return this.commentTypes;
    },
  },

  methods: {
    selectCommentType(type, text) {
      this.commentType = type;
      this.commentTypeText = text;
    },

    retrieve() {
      if (this.jobCommentId) {
        const retrieve_url = '/ritten/comment/get-files/' + this.jobCommentId;
        this.uploading = true;

        this.$http.get(retrieve_url).then(function (response) {
          this.files = response.data;
          this.uploading = false;
        });
      }
    },

    submit() {
      this.submitting = true;
      let url = '/ritten/comment/' + this.jobId;
      if (this.jobCommentId) {
        url = url + '/' + this.jobCommentId;
      }

      const fields = {
        comment: this.comment,
        type: this.commentType
      };

      this.$http.post(url, fields).then(function (response) {
        this.errors = {};
        this.submitting = false;
        this.comment = '';
        this.files = [];
        this.jobCommentId = null;

        this.$emit('submitted', response.data);
      }, function (response) {
        this.submitting = false;
        this.errors = response.body.errors;
      });
    },

    remove(file) {
      this.loading = true;
      const remove_url = '/ritten/comment/delete-file/' + file.id;

      this.$http.get(remove_url).then(function (response) {
        this.loading = false;
        this.retrieve();
      });
    },

    upload(e) {
      const files = e.target.files;

      let upload_url = '/ritten/comment/upload-file/' + this.jobId;
      if (this.jobCommentId) {
        upload_url = upload_url + '/' + this.jobCommentId;
      }

      if (files.length > 0) {
        this.uploading = true;
        this.$refs.submitbtn.disabled = true;

        // Chunk object in porties van 20MB (20000000 bytes)
        const chunks = [[]];
        let chunkBytes = 0;

        for (let key = 0; key < files.length; key++) {
          if ((chunkBytes + files[key].size) > 20000000) {
            chunks.push([]);
            chunkBytes = 0;
          }
          chunks[chunks.length - 1].push(files[key]);
          chunkBytes += files[key].size;
        }

        for (let key in chunks) {
          const formData = new FormData();
          for (let cKey in chunks[key]) {
            formData.append('uploads[]', chunks[key][cKey]);
          }

          this.$http.post(upload_url, formData).then(function (response) {
            this.uploading = false;
            this.$refs.submitbtn.disabled = false;
            this.jobCommentId = response.data.commentId;
            this.retrieve();
          }, function (response) {
            this.uploadError = true;
            this.uploading = false;
            this.$refs.submitbtn.disabled = false;
          });
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Job/Comments/Form.vue